import createIcon from '../../createIcon';

/**
 * @component @name LibraryAddCheck
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMkg4QzYuOSAyIDYgMi45IDYgNFYxNkM2IDE3LjEgNi45IDE4IDggMThIMjBDMjEuMSAxOCAyMiAxNy4xIDIyIDE2VjRDMjIgMi45IDIxLjEgMiAyMCAyWk0xMi40NyAxNEw5IDEwLjVMMTAuNCA5LjA5TDEyLjQ3IDExLjE3TDE3LjYgNkwxOSA3LjQxTDEyLjQ3IDE0Wk00IDZIMlYyMEMyIDIxLjEgMi45IDIyIDQgMjJIMThWMjBINFY2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LibraryAddCheck = createIcon('LibraryAddCheck', [
  [
    'path',
    {
      d: 'M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM12.47 14L9 10.5L10.4 9.09L12.47 11.17L17.6 6L19 7.41L12.47 14ZM4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6Z',
      key: 'jifox7',
    },
  ],
]);

export default LibraryAddCheck;
